import { TranslateService } from '@ngx-translate/core'
import { Subject } from "../model/subject"
import { Answer } from "../model/exercises/quiz"

/**
 * Some useful functions for working with languages and translations.
 */

let translateService: TranslateService = null

/**
 * Before calling other methods in this file, this function must be called.
 */
export function initTranslate(translate: TranslateService) {
	translateService = translate
}

/**
 * Translates the given string with optional params into the current language.
 */
export function translate(text: string, params?: Object): string {
	if (translateService == null)
		return text;
	return translateService.instant(text, params)
}

/**
 * Translates the given quiz answer into the current language.
 */
export function translateAnswer(subject: Subject<any, any>, answer: Answer): string {
	if (translateService == null)
		return answer;
	return translateService.instant(subject.id + "-answer-" + answer)
}


// WEBPACK FOOTER //
// ./src/utils/lang-utils.ts